
import {Button, Col, ConfigProvider, Form, Input, Modal, Row, Select, Switch} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {PostProveidors} from "../../../dao/menudesign/PostProveidors";
import React, {useContext, useEffect, useState} from 'react';
import {AuthContext} from "../../../config/AuthContext";

const { Option } = Select;
interface ProveidorModalProps {
    element: object;
    visible: boolean;
    onClose: (value: boolean) => void;
    editar?: boolean;
}

const ProveidorModal: React.FC<ProveidorModalProps> = ({element, visible, onClose, editar}) => {
    const [form] = Form.useForm();
    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const tipus = Form.useWatch('tipus', form);


    async function handleSubmit () {
        const formData = form.getFieldsValue();
        await PostProveidors(page, formData, userId);


        onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Crear/Editar Proveïdor"
                open={visible}
                onCancel={handleCancel}
                footer={[
                ]}
                width={1000}
            >
                <Form form={form} initialValues={element} onFinish={handleSubmit} disabled={!editar}>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={12}>
                            <Form.Item label="ID" name="id">
                                <Input disabled/>
                            </Form.Item>
                            <Form.Item label="Nombre" name="nom"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label="Responsable" name="responsable"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input />
                            </Form.Item>
                            <Form.Item label="Telèfon" name="telefon"
                            
                            rules={[
                                { required: true, message: 'Aquest camp és obligatori' },
                                {
                                validator: (_, value) => {
                                    if (!value || value.length <= 9) {
                                    return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('El número no pot tenir més de 9 dígits'));
                                },
                                },
                            ]}
                            >
                                <Input /> 
                            </Form.Item>
                          

                           

                        </Col>
                        <Col span={12}>
                          <Row gutter={[8, 8]}>
                                <Col span={14}>
                                    <Form.Item label="Email" name="email"
                                               rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <Input/>
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item label="Email automàtic" name="emailing">
                                        <Switch />
                                    </Form.Item>
                                </Col>
                            </Row>

                         <Form.Item label="Recordatori" name="recordatori"
                                       rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                <Input type='number'/>
                            </Form.Item>
                            
                               
                                    <Form.Item label="Reparteix" name="reparteix"
                                               rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <Select
                                            placeholder="Selecciona"
                                            disabled={!editar}
                                        >
                                            <Option value= {1} >Magatzem</Option>
                                            <Option value={0}>Escoles</Option>

                                        </Select>
                                    </Form.Item>
                                
                                    <Form.Item label="Comanda" name="comanda"
                                               rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                        <Select
                                            placeholder="Selecciona"
                                            disabled={!editar}
                                        >

                                            <Option value= {1} >Proposta cuineres</Option>
                                            <Option value={0}>Precisió</Option>

                                        </Select>
                                    </Form.Item>
                                
                            
                           
                        </Col>
                    </Row>
                    <hr/>
                    <Row gutter={[16, 16]}>
                        <Col span={1}>
                            <Form.Item wrapperCol={{offset: 0, span: 16}}>
                                <Button title={"Aceptar"} htmlType={"submit"}
                                        style={{backgroundColor: Colors.colors.color6}}><BiCheck/></Button>
                            </Form.Item>
                        </Col>
                        <Col span={1}>
                        </Col>
                        <Col span={1}>
                            <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                                    onClick={handleCancel}><BiX/></Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default ProveidorModal;
